import { Box, Stack, Typography, useTheme } from '@mui/material';
import type { ReactNode } from 'react';

interface ChatPanelTitleProps {
  /**
   * OR-6455: optional trailing content on this row — the read-only
   * snapshot's Refresh action + "as of HH:MM" timestamp lives here rather
   * than on the chat-switcher row below (which spans full width for the
   * picker itself). Omitted by every other caller.
   */
  trailingContent?: ReactNode;
}

/**
 * Persistent "Research Assistant" title at the top of the project chat panel
 * (OR-6123 — Figma 401-7342). Rendered in both the active-chat and the
 * empty/switcher states so the panel always identifies itself above the
 * session-selector row.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const ChatPanelTitle = ({ trailingContent }: ChatPanelTitleProps = {}) => {
  const theme = useTheme();
  return (
    <Box
      data-testid="chat-panel-title"
      sx={{
        flexShrink: 0,
        paddingX: 3,
        paddingTop: 1.5,
        // Tight bottom padding (no divider) so the title sits close above the
        // chat-session selector row — per Figma 401-7342.
        paddingBottom: 0.5,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h6" component="h2">
          Research Assistant
        </Typography>
        {trailingContent}
      </Stack>
    </Box>
  );
};
